import React from "react"

import { useApiContext } from "~/api"
import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content"

const Procurement: React.FC = () => {
  const { name } = useApiContext("/procurement/element")

  return (
    <Layout headerTheme="onLight" title={name}>
      <Content />
    </Layout>
  )
}

export default Procurement
